import { SET_OPEN_MENU, SET_OPEN_SEGURADO_FORM, SET_ULTIMO_UPDATE_LISTA_SEGURADOS, SET_ULTIMO_UPDATE_NIT } from "../../actionTypes"

export const setOpenMenu = (open) => {
    return {
        type: SET_OPEN_MENU,
        payload: { open }
    }
}

export const setOpenSeguradoForm = (open, cpf = null) => {
    return {
        type: SET_OPEN_SEGURADO_FORM,
        payload: { open, cpf }
    }
}

export const setUltimoUpdateListaSegurados = (data = new Date()) => {
    return {
        type: SET_ULTIMO_UPDATE_LISTA_SEGURADOS,
        payload: { data }
    }
} 

export const setUltimoUpdateNit = (data = new Date()) => {
    return {
        type: SET_ULTIMO_UPDATE_NIT,
        payload: { data }
    }
} 